import { Typography } from "@stardust-ds/react"

import styles from "./index.module.scss";
import RcmpTooltip from "../../atoms/Tooltip";

export default function RcmpEmptyContentPage(props) {
  const { bShow, cMessage, cActionMessage, fnOnAction, cQuestion, cAnswer, image, bShowAction=true } = props

  if (!bShow) return null

  return (
    <div className={styles.noCardsHead}>
      <Typography type="h5" color="#415364">
        {cMessage}{" "}
        {cActionMessage && bShowAction && (
          <a onClick={fnOnAction}>
            {cActionMessage}
          </a>
        )}
      </Typography>
      <div className={styles.noCards}>
        <Typography type="p2" color="#415364">
          {cQuestion}
        </Typography>
        <RcmpTooltip>
          {cAnswer}
        </RcmpTooltip>
      </div>
      <img src={image} />
    </div>
  )
}